import { AlertOutlined, CommentOutlined } from "@ant-design/icons";
import { IDrone } from "@drone-parts.garphild.pro/interfaces";
import PrintLabel from "../../print-label";

interface IInfoTabProps {
  drone: IDrone;
  qrCode: string | undefined;
}

export default function InfoTab({ drone, qrCode }: IInfoTabProps) {
  return (
    <div>
      {qrCode && (
        <div>
          {/* <img src={qrCode} alt="qr code" style={{ maxWidth: '100%' }} /> */}
          <PrintLabel drone={drone} qrCode={qrCode} />
        </div>
      )}
      {!!drone.comments?.length && (
        <div style={{ marginTop: 16 }}>
          <h4><CommentOutlined /> Comments:</h4>
          <ul>
            {drone.comments.map((comment, index) => (
              <li key={index}>
                <strong>{comment.author || 'System'}:</strong> {comment.text}
                {comment.createdAt && (
                  <span style={{ color: 'gray', fontSize: '0.8em', marginLeft: 8 }}>
                    {new Date(comment.createdAt).toLocaleString()}
                  </span>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
